import toast from "react-hot-toast";

/**
 * Thin wrapper around react-hot-toast with built-in deduplication.
 *
 * Dedup mechanism: uses a deterministic toast ID derived from the message,
 * so calling notify.success("Saved") twice rapidly shows only one toast.
 */

function toastId(message: string): string {
	return `notify-${message}`;
}

export const notify = {
	success(message: string) {
		toast.success(message, { id: toastId(message) });
	},

	error(message: string) {
		toast.error(message, { id: toastId(message) });
	},

	warning(message: string) {
		toast(message, { id: toastId(message), icon: "\u26A0\uFE0F" });
	},

	info(message: string) {
		toast(message, { id: toastId(message), icon: "\u2139\uFE0F" });
	},

	promise<T>(
		promise: Promise<T>,
		msgs: { loading: string; success: string; error: string },
	) {
		return toast.promise(promise, msgs);
	},
};
